import React from 'react';
import PropTypes from 'prop-types';

import { getI18n } from '@/utils/i18n';

import styles from './JobDescription.cm.styl';

const i18n = getI18n();

function JobDescription(props) {
  const { jobDescription = {} } = props;
  return (
    <div>
      <div className={styles.list}>
        <div className={styles.title}>
          {i18n.t`职位描述`}
          <div className={styles.hr} />
        </div>
        <div
          className={styles.desc}
          dangerouslySetInnerHTML={{ __html: jobDescription || i18n.t`暂无` }}
        />
      </div>
    </div>
  );
}

JobDescription.propTypes = {
  jobDescription: PropTypes.string,
};

export default JobDescription;
